import { useCallback } from 'react';

import { withPresence } from 'hocs';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { useFavoriteAgents } from 'utils/useFavoriteAgents';

import { presenceActions } from '../../presence/actions/presenceActions';
import { teamActions } from '../actions/teamPage';
import { TeamPage as TeamPageImpl, TeamPageStatePropsT } from '../components';

const { selectTeamMembersFilter, setPresenceFilters } = teamActions;

const TeamPageWithPresence = withPresence(TeamPageImpl, { pageSize: 50 });

const LegacyTeamPage = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { favoriteAgentIds } = useFavoriteAgents();

  const presenceFilters = useAppSelector(
    (state) => state.team.presenceFilters,
  ) as TeamPageStatePropsT['presenceFilters'];

  const selectTeamMembersFilterFn = useCallback(
    (filter: string) => dispatch(selectTeamMembersFilter({ filter })),
    [dispatch],
  );

  const setPresenceFiltersFn = useCallback(
    (params: TeamPageStatePropsT['presenceFilters']) =>
      dispatch(setPresenceFilters(params)),
    [dispatch],
  );

  const presenceGetAll = useCallback(
    (userId: string) =>
      bindActionToPromise(dispatch, presenceActions.presenceGetAll)(userId),
    [dispatch],
  );

  return (
    <TeamPageWithPresence
      favourites={favoriteAgentIds as string[]}
      presenceFilters={presenceFilters}
      selectTeamMembersFilter={selectTeamMembersFilterFn}
      setPresenceFilters={setPresenceFiltersFn}
      presenceGetAll={presenceGetAll}
    />
  );
};

export { LegacyTeamPage };
